import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Breadcrumb.css';
import '../Styles/Home.css'; // 引入動畫樣式

function Breadcrumb() {
  const location = useLocation();
  const { t } = useTranslation();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 頁面動畫載入效果
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 50); // 較短的延遲，使麵包屑先出現
    
    return () => clearTimeout(timer);
  }, []);

  // 如果是主頁，不顯示麵包屑
  if (location.pathname === '/') {
    return null;
  }

  const pathnames = location.pathname.split('/').filter((x) => x);

  // 創建麵包屑項目
  const breadcrumbItems = [
    {
      name: t('breadcrumb.home'), // 這裡已經正確使用了breadcrumb前綴
      path: '/',
    },
    ...pathnames.map((path, index) => {
      // 將路徑轉換為可讀的名稱（作為後備顯示）
      let name =
        path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, ' ');

      // 嘗試使用breadcrumb.前綴來翻譯路徑
      try {
        // 使用 breadcrumb.${path} 作為翻譯鍵
        const translationKey = `breadcrumb.${path}`;
        const translatedName = t(translationKey, { fallback: name });
        name = typeof translatedName === 'string' ? translatedName : name;
      } catch (error) {
        console.error(`Translation error for key breadcrumb.${path}:`, error);
      }

      // 生成到這個層級的完整路徑
      const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;

      return {
        name,
        path: routeTo,
      };
    }),
  ];

  return (
    <div className={`breadcrumb ${isLoaded ? 'fade-in-element' : 'content-hidden'}`}>
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;

        return (
          <span key={item.path}>
            {!isLast ? (
              <>
                <Link to={item.path}>{item.name}</Link>
                <span className="separator">/</span>
              </>
            ) : (
              <span className="current">{item.name}</span>
            )}
          </span>
        );
      })}
    </div>
  );
}

export default Breadcrumb;
